module.exports = __webpack_public_path__ + "static/media/icon-catalog-feed.e9d5d030.svg";